import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
  illustration: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  illustrationImg: {
    maxWidth: '100%',
    height: 'auto'
  },
  subtitle: {
    marginBottom: theme.spacing(3)
  },
  infoBar: {
    display: 'flex',
    gap: theme.spacing(1),
    padding: theme.spacing(1, 1),
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.info.main,
    color: theme.palette.info.contrastText
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2)
  }
}));
